import pickBy from 'lodash/pickBy.js';
import queryString from 'query-string';
export const imageBaseUrl = 'https://images.takeshape.io';
export const assetBaseUrl = 'https://assets.takeshape.io';
export function getPath(key) {
    return typeof key === 'object' ? ('path' in key ? key.path : key.s3Key) : key;
}
function formatQuery(query) {
    if (query) {
        const filtered = pickBy(query, (value) => value !== '');
        if (Object.keys(filtered).length) {
            return `?${queryString.stringify(filtered)}`;
        }
    }
    return '';
}
function escapePath(path) {
    return path.split('/').map(encodeURIComponent).join('/');
}
export function getAssetUrl(s3Key, options = {}) {
    const path = getPath(s3Key);
    const baseUrl = options.baseUrl ?? assetBaseUrl;
    return path ? `${baseUrl}/${escapePath(path)}` : '';
}
export function getImageUrl(key, query, options = {}) {
    const path = getPath(key);
    const baseUrl = options.baseUrl ?? imageBaseUrl;
    return path ? `${baseUrl}/${escapePath(path)}${formatQuery(query)}` : '';
}
